import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select } from "antd";
import { SingleImageUpload } from "components/SingleImageUpload";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { api } from "services/api";
import Swal from "sweetalert2";
// import { IAddCourses } from "types";
import { getBase64Img } from "utils";

export const EditCourseModal: React.FC<any> = ({ ...props }) => {
	const [value, setValue] = useState<string>("");
	const [currTags, setCurrTags] = useState<string[]>([]);
	const [option, setOption] = useState<string>("");
	const [courseHighlight, setCourseHighlight] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);
	const [isActive, setIsActive] = useState<boolean>(false);
	const [courseStatus, setCourseStatus] = useState<boolean>(false);

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		currentImgURL,
		currentCourseData,
		onUpdated
	} = props;

	const setIsActiveAndReviewCourseStatus = (isActiveParam: boolean) => {
		setIsActive(isActiveParam)
		if(!isActiveParam) {
			setCourseStatus(false)
		}
	}

	const handleChange = (value: any) => {
		setCurrTags(value);
	};

	const handleRegister = (values: any) => {
		api
			.put(`/courses/${currentCourseData?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					onUpdated(result.data)
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
						setCourseStatus(false);
						setIsActive(false);
						setCourseHighlight(false);
						setCurrentImgURL("");
						setCurrTags([]);
						setCourseStatus(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};
	const { Option } = Select;

	useEffect(() => {
		if (isOpen) {
			form?.setFieldsValue({
				title: currentCourseData?.title,
				subtitle: currentCourseData?.subtitle
					? currentCourseData?.subtitle
					: "",
				age: currentCourseData?.age,
				visibility:
					currentCourseData?.visibility === "public" ? "public" : "private",
				description: currentCourseData?.description,
				author: currentCourseData?.author,
				tags: currentCourseData?.tags? currentCourseData.tags.split(', '): []
			});
			setOption(
				currentCourseData?.visibility === "public" ? "public" : "private"
			);
			setIsActive(currentCourseData?.is_active === true ? true : false);
			setCourseHighlight(
				currentCourseData?.is_highlight === true ? true : false
			);
			setCourseStatus(currentCourseData?.status === "publish" ? true : false);
			setCurrentImgURL(
				currentCourseData?.image ? currentCourseData?.image : ""
			);
			setValue(currentCourseData?.content ? currentCourseData?.content : "");
			const noDataName = document.getElementsByClassName(
				"ant-empty-description"
			)[0];

			setCurrTags(currentCourseData?.tags? currentCourseData.tags.split(', '): []);
			// @ts-ignore
			if (noDataName) {
				console.log(noDataName);
			}
		}
		// eslint-disable-next-line
	}, [isOpen]);

	const handleChangeImage = (imageUrl: string) => {
		setImageWasEdited(true)
		setCurrentImgURL(imageUrl)
	} 

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Editar curso</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar curso"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									tags: currTags.join(", "),
									status: courseStatus === true ? "publish" : "pending",
									image: currentImgURL,
									image_to_list: currentImgURL,
									visibility: option,
									is_highlight: courseHighlight,
									is_active: isActive,
									subtitle: form.getFieldValue("subtitle"),
									content: value,
							  }
							: {
									...values,
									tags: currTags.join(", "),
									status: courseStatus === true ? "publish" : "pending",
									visibility: option,
									is_highlight: courseHighlight,
									is_active: isActive,
									subtitle: form.getFieldValue("subtitle"),
									content: value,
							  };
						handleRegister(allValues);
					})
					.catch((info: any) => {
						// console.log("Validate Failed:", info);
					})
					.finally(() => {
						setImageWasEdited(false)
						setCurrentImgURL("");
					});;
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				form.resetFields();
			}}
			width={700}
		>
			<Form form={form} name="new-course" autoComplete="off" layout="vertical">
				<div className="row row-cols-1 row-cols-md-2 justify-content-center align-items-center pe-0">
					<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={handleChangeImage}/>
					
					<div>
						<Form.Item
							label="Título"
							name="title"
							rules={[
								{
									required: true,
									message: "Título necessário",
								},
							]}
						>
							<Input id="title" placeholder="Título do curso" />
						</Form.Item>
						<Form.Item
							label="Subtítulo"
							name="subtitle"
							rules={[
								{
									required: true,
									message: "Subtítulo necessário",
								},
							]}
						>
							<Input id="subtitle" placeholder="Subtítulo do curso" />
						</Form.Item>
						<Form.Item
							label="Autor"
							name="author"
							rules={[
								{
									required: true,
									message: "Autor necessário",
								},
							]}
						>
							<Input id="author" placeholder="Autor" />
						</Form.Item>
					</div>
				</div>
				<div className="row row-cols-1">
					<div>
						<Form.Item
							label="Descrição"
							name="description"
							rules={[
								{
									required: true,
									message: "Descrição necessária",
								},
							]}
						>
							<Input className="form-control" id="description" placeholder="Descrição do curso" />
						</Form.Item>
					</div>
				</div>
				<div className="row row-cols-1 row-cols-md-2">
					<div>
						<Form.Item name="tags" label="Tags">
							<Select
								mode="tags"
								placeholder="Tags"
								onClick={() => {
									const noDataName = document.getElementsByClassName(
										"ant-empty-description"
									)[0];

									if (noDataName) {
										noDataName.innerHTML = "Nenhuma tag cadastrada";
									}
								}}
								tokenSeparators={[","]}
								onChange={handleChange}
							>
							</Select>
						</Form.Item>
					</div>
					<div>
						<Form.Item
							label="Classificação indicativa"
							name="age"
							rules={[
								{
									required: true,
									message: "Classificação necessário",
								},
							]}
						>
							<Input id="age" placeholder="Classificação indicativa" />
						</Form.Item>
					</div>
				</div>
				<div className="row">
					<div className="col-12 col-md-4">
						<Form.Item
							label="Visibilidade"
							name="visibility"
							rules={[
								{
									required: true,
									message: "Visibilidade necessária",
								},
							]}
						>
							<Select
								id="visibility"
								placeholder="Visibilidade"
								className="select"
								value={option}
								onChange={(e) => setOption(e)}
							>
								<Option value="public">Público</Option>
								<Option value="private">Privado</Option>
							</Select>
						</Form.Item>
					</div>
					<div className="col-12 col-md-8 row row-cols-3 pb-3 align-items-center text-center">
						<div>
							<p>Publicado</p>
							<Switch
								disabled={isActive === false}
								checked={courseStatus}
								onClick={(e) => setCourseStatus(e)}
							/>
						</div>
						<div>
							<p>Destacar</p>
							<Switch
								checked={courseHighlight}
								onClick={(e) => setCourseHighlight(e)}
							/>
						</div>
						<div>
							<p>Ativo</p>
							<Switch checked={isActive} onClick={(e) => setIsActiveAndReviewCourseStatus(e)} />
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col-12">
						<ReactQuill theme="snow" value={value} onChange={setValue} />
					</div>
				</div>
			</Form>
		</Modal>
	);
};
